module.exports = __webpack_public_path__ + "static/media/bobber.bf47f9dd.glb";